import React, {
  useRef,
  useState,
  useEffect,
  Dispatch,
  SetStateAction,
} from 'react';
import { Link, NavLink } from 'react-router-dom';
import { IoIosMenu } from 'react-icons/io';
import { FaChevronDown } from 'react-icons/fa';
// import logo from '../../assets/images/logo.png';
import newlogo from '../../assets/images/newlogo.png';

import AuthHeaderMenu from '../AuthHeaderMenu';
// import TopNav from '../TopNav';
import styles from './Header.module.scss';
import { NavLinks } from '../TopNav/Navlinks';
import { useOnclickOutside } from '../../hooks/useOnclickOutside';
import { useDetectScroll } from '../../hooks/useDetectScroll';

interface Props {
  setShowMenu: Dispatch<SetStateAction<boolean>>;
  showMenu: boolean;
  toggleShowMenu: () => void;
}

const Header: React.FC<Props> = ({ setShowMenu, showMenu, toggleShowMenu }) => {
  // const [showMenu, setShowMenu] = React.useState<boolean>(false);

  const wrapperRef = useRef(null);
  useOnclickOutside(wrapperRef, setShowMenu);

  const { scrollDir } = useDetectScroll();

  useEffect(() => {
    // console.log("checking scroll-- ", scrollDir)
  }, [scrollDir]);

  // console.log("show menu header-- ", showMenu)

  const [hovered, setHovered] = useState(false);

  return (
    <div className={styles.header}>
      <div className="container flex flex-wrap items-center justify-between mx-auto ">
        <div
          id="logo"
          className="flex items-center justify-between w-3/12 h-full lg:w-2/12"
        >
          <Link to="/">
            <img src={newlogo} className="h-12" alt="GIGL" />
          </Link>
        </div>
        <div className="flex items-center justify-end w-9/12 lg:hidden ">
          <AuthHeaderMenu />
          <IoIosMenu
            onClick={() =>
              // setShowMenu(!showMenu);
              toggleShowMenu()
            }
            className="text-4xl cursor-pointer"
          />
        </div>
        <div
          className={`w-full lg:w-10/12  ${
            !showMenu ? 'hidden' : 'flex'
          } lg:flex flex-wrap h-full items-center`}
        >
          <div className="flex justify-between w-full lg:w-6/12">
            {/* <TopNav /> */}

            <nav
              className="flex flex-wrap justify-between w-full font-serif "
              ref={wrapperRef}
            >
              {/* className={clicked ? `hidden lg:flex flex-wrap justify-between w-full font-serif` : ' flex flex-wrap justify-between w-full font-serif'}
    > */}
              {NavLinks.map((link) => (
                <div
                  key={link.id}
                  className={`font-medium text-sm relative flex flex-wrap lg:block w-full lg:w-auto  ${
                    link.hasSubmenu ? styles.hasSubmenu : ''
                  }`}
                >
                  <NavLink
                    activeClassName="text-primary"
                    className="flex items-center justify-between w-full py-4 hover:text-primary lg:py-0"
                    to={{ pathname: link.url }}
                    target={link.external ? '_blank' : '_self'}
                    onClick={() => {
                      if (!link.hasSubmenu) {
                        // setShowMenu(!showMenu)
                        toggleShowMenu();
                      }
                    }}
                  >
                    {link.title}
                    {link.hasSubmenu && (
                      <FaChevronDown className="inline-flex ml-2 text-xs" />
                    )}
                  </NavLink>

                  {link.submenu && (
                    <div
                      className={` relative lg:absolute lg:py-3 flex-col lg:shadow lg:rounded-lg w-full lg:w-52 bg-white lg:bg-white ${styles.subMenu}`}
                    >
                      {link.submenu.map((menu) => (
                        <div
                          key={menu.id}
                          className="relative"
                          onMouseEnter={() =>
                            setHovered(menu.title === 'Global Shipping')
                          }
                          onMouseLeave={() => setHovered(false)}
                        >
                          <Link
                            className="flex w-full px-3 py-3 border-b border-gray-200 lg:border-none lg:px-6 hover:text-primary"
                            to={{ pathname: menu.url }}
                            target={menu.external ? '_blank' : '_self'}
                            onClick={() => toggleShowMenu()}
                          >
                            {menu.title}
                                      {/* Show the FaChevronDown for the "Global Shipping" submenu */}
                                      {menu.hasSubmenu && hovered && menu.title === 'Global Shipping' && (
            <FaChevronDown className="ml-2 text-xs" />
          )}
                          </Link>

                          {menu.hasSubmenu &&
                            hovered &&
                            menu.title === 'Global Shipping' && (
                              <div className="absolute left-0 z-50 w-full py-2 overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg lg:left-full lg:top-0 lg:w-full lg:py-3 max-h-60 lg:max-h-none">
                                {menu.submenu.map((subMenu) => (
                                  <Link
                                    key={subMenu.id}
                                    className="block w-full px-3 py-2 hover:bg-gray-100 hover:text-primary whitespace-nowrap"
                                    to={{ pathname: subMenu.url }}
                                    target={
                                      subMenu.external ? '_blank' : '_self'
                                    }
                                  >
                                    {subMenu.title}
                                  </Link>
                                ))}
                              </div>
                            )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </nav>
          </div>
          <div className="flex justify-between w-full lg:w-6/12">
            <AuthHeaderMenu inMobile />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
